<template>
    <div>
      <Head :title="__(title)" />
     
      <div class="overflow-x-auto bg-white rounded-md shadow">
        <table class="w-full whitespace-nowrap">
            <tbody>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">{{ __('Date') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Contenu') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Destinataire') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Statut') }}</th>
            <th class="px-6 pt-6 pb-4">{{ __('Prix') }}</th>
          </tr>
          <tr v-for="call in calls"  class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" >
                {{ call['start_time'] }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4"  tabindex="-1">
                {{ call['body'] }}
              </Link>
            </td>
           
            <td class="border-t">
              <Link class="flex items-center px-6 py-4"  tabindex="-1">
                {{ call['to'] }}
              </Link>
            </td>
            
            <td class="border-t">
                <Link class="flex items-center px-6 py-4"  tabindex="-1">
                <div class="flex p-2 space-x-2 text-white rounded-full bg-violet-300">
                    <div class="w-2 h-2 bg-blue-400 rounded-full animate-ping"></div>
                    <div>{{ call['status'] == 'delivered' ? 'Livré': 'Non livré' }}</div>
                </div>
              </Link>
            </td>
            <!-- <td class="border-t">
                <div v-if="call['audio_url']">
                    <audio  controls :src="call['audio_url']"></audio>
                </div>
            </td> -->
            <td class="border-t">
                <Link class="flex items-center px-6 py-4"  tabindex="-1">
                  {{ call['cost'] }}
                </Link>
            </td>
          </tr>
          <tr v-if="calls.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">Aucun sms trouvé</td>
          </tr>
            </tbody>
        </table>
      </div>
      <!-- <div v-if="pagination.links.length > 3"> -->
        <div v-if="pagination && pagination['links']" class="flex flex-wrap -mb-1 p-nat">
          <template v-for="(link, key) in pagination['links']">
            <div v-if="link.url === null" :key="key" class="px-4 py-3 mb-1 mr-1 text-sm leading-4 text-gray-400 border rounded" v-html="link.label" />
            <Link v-else :key="key+1" class="px-4 py-3 mb-1 mr-1 text-sm leading-4 border rounded" :class="{ 'active': link.active }" :href="getLinkPage(link.url)" v-html="link.label" />
          </template>
        </div>
      <!-- </div> -->
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import SearchInput from '@/Shared/SearchInput'
  
  export default {
    components: {
        SearchInput,
      Head,
      Icon,
      Link,
      Pagination,
    },
    layout: Layout,
    props: {
      filters: Object,
      calls: Object,
      title: String,
      pagination: Object,
    },
    data() {
      return {
        
      }
    },
    watch: {
      
    },
    created() {
    },
    methods: {
      reset() {
        
      },
      getLinkPage(url) {
      // Si l'URL existe, extraire la page à partir de la chaîne après `page=`
      if (url) {
        const page = new URL(url).searchParams.get('page');
        return `?page=${page}`; // Générer l'URL relative avec la page
      }
      return ''; // Retourne une chaîne vide si l'URL est nulle
    }
    },
  }
  </script>
  
